// local enable this

export const API_URL = process.env.NODE_ENV==="development"?"http://10.2.3.150:8080/":"https://api.demo.dolphin.com.np/_api/";
// live enable this
// export const API_URL = "https://pis.dev.mavorion.com/api";


export default API_URL;
